import { useId, type ReactNode } from "react";

export interface PocketSectionProps {
  /** Section label: 12px/1.35, 600, uppercase, .08em, --color-muted. */
  title?: ReactNode;
  /** Right side of the title row ("Accept all", "Mark all read"). */
  action?: ReactNode;
  testId?: string;
  children: ReactNode;
}

/**
 * PocketSection — a group of PocketRows under an optional section label
 * (compact surface standard §5). Sections are 14px apart and never use lines
 * or borders. Used by the tray, the Settings pocket and the search hub.
 */
export function PocketSection({
  title,
  action,
  testId,
  children,
}: PocketSectionProps) {
  const labelId = useId();
  return (
    <section
      className="mt-3.5 first:mt-0"
      data-testid={testId}
      aria-labelledby={title ? labelId : undefined}
    >
      {title || action ? (
        <div className="flex items-center gap-3.5 px-2 pb-1">
          {title ? (
            <span
              id={labelId}
              className="text-appkit-caption font-semibold uppercase tracking-[0.08em] text-muted"
              data-pocket-section-label=""
            >
              {title}
            </span>
          ) : null}
          {action ? (
            <div className="ml-auto flex items-center gap-3.5 text-appkit-caption font-medium text-muted">
              {action}
            </div>
          ) : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
